import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ItemService } from '@services/item.service';
import { QuestionSubTypeIdEnum, QuestionTypeIdEnum } from '@configs/questions.config';

@Component({
  selector: 'app-item-preview',
  templateUrl: './item-preview.component.html',
  styleUrls: ['./item-preview.component.scss']
})
export class ItemPreviewComponent {
  @ViewChild('table') table: MatTable<any>;
  @ViewChild('itemPreview', { static: true }) itemPreview: TemplateRef<any>
  displayedColumns: string[] = ['itemBankName', 'itemDescription'];
  questions: any;
  itemBasicDetails = {
    itemBankName: '',
    itemDescription: '',
    collectionId: '',
    itemBankId: '',
    isPublished: false,
    numberOfQuestions: 0
  };
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  constructor(private itemService: ItemService, private dialog: MatDialog) { }

  showPopup(data: any) {
    this.dialog.open(this.itemPreview, { width: '100%', height: '600px', panelClass: 'dialog-container' });
    this.questions = []
    if (data && data.id) {
      this.questions = new MatTableDataSource(data?.name?.data);
      this.questions = this.questions.data.sort((a, b) => (a.questionOrder - b.questionOrder));
      this.itemBasicDetails.numberOfQuestions = data?.name?.data?.length;

      //code is commented because of loading issues
      // const itemSubscription = this.itemService.getItemDetails(`${data.id}`).subscribe((resData) => {
      //   this.questions = new MatTableDataSource(resData?.data?.questions);
      //   this.questions = this.questions.data.sort((a, b) => (a.questionOrder - b.questionOrder));
      //   this.itemBasicDetails.collectionId = sessionStorage.defaultcollectionid;
      //   this.itemBasicDetails.numberOfQuestions = resData?.data?.questions?.length;
      //   this.itemBasicDetails.itemBankName = resData?.data?.itemBankName;
      //   this.itemBasicDetails.itemDescription = resData?.data?.itemDescription;
      //   this.itemBasicDetails.itemBankId = resData?.data?.itemBankId;
      //   this.itemBasicDetails.isPublished = resData?.data?.statusName === 'Published';
      // }, () => { }, () => itemSubscription.unsubscribe());
    }
  }

  onClosePreview() {
    this.dialog.closeAll();
  }
}
